module.exports = __webpack_public_path__ + "static/media/May_2026_3.65dea3ba.webp";